import React, { useMemo } from 'react';
import { Close, Search } from '@mui/icons-material';
import { Box, Chip, IconButton, InputAdornment, Stack, TextField } from '@mui/material';

const STATUS_OPTIONS = [
  { key: 'all', label: 'Todos', color: 'default' },
  { key: 'ok', label: 'OK', color: 'success' },
  { key: 'shortage', label: 'Faltante', color: 'warning' },
  { key: 'priceDiff', label: 'Diferencia precio', color: 'error' },
  { key: 'promotional', label: 'Promo', color: 'secondary' },
  { key: 'discount', label: 'Descuento', color: 'info' },
  { key: 'review', label: 'Revisar', color: 'default' },
];

const normalize = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

export default function InvoiceDetailSearchBar({
  query = '',
  status = 'all',
  onQueryChange,
  onStatusChange,
}) {
  const tokens = useMemo(() => normalize(query).split(/\s+/).filter(Boolean), [query]);

  return (
    <Stack spacing={0.9}>
      <TextField
        size="small"
        placeholder="Buscar por codigo, producto o descripcion"
        value={query}
        onChange={(event) => onQueryChange?.(event.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: query ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => onQueryChange?.('')} sx={{ p: 0.5 }}>
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{ '& .MuiInputBase-input': { fontSize: '0.82rem' } }}
      />
      <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
        {STATUS_OPTIONS.map((item) => {
          const active = String(status || 'all') === item.key;
          return (
            <Chip
              key={item.key}
              label={item.label}
              size="small"
              color={active ? item.color : 'default'}
              variant={active ? 'filled' : 'outlined'}
              onClick={() => onStatusChange?.(item.key)}
              sx={{ height: 22, '& .MuiChip-label': { fontSize: '0.68rem', px: 0.75 } }}
            />
          );
        })}
      </Stack>
      {tokens.length > 0 && (
        <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
          {tokens.map((token) => (
            <Chip
              key={token}
              label={token}
              size="small"
              variant="outlined"
              sx={{ borderStyle: 'dashed', height: 20, '& .MuiChip-label': { fontSize: '0.66rem' } }}
            />
          ))}
        </Box>
      )}
    </Stack>
  );
}
